import React, { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import moment from "moment";
import { t } from "i18next";
import ApiService from "../../api/ApiService";
import AppContext from "../../context/AppContext";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const MediaHistoryComponent = () => {
  const { user } = useContext(AppContext);
  console.log("user Name", user.id);
  const currentYear = new Date().getFullYear();
  const [mediaData, setMediaData] = useState([]);
  const [isAPILoading, setIsAPILoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(`${currentYear}`);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;
  const yearsList = [currentYear, currentYear - 1 , currentYear - 2];

  useEffect(() => {
    if (!user) return;

    const fetchMedia = async () => {
      setIsAPILoading(true);
      console.log("I am in history");

      try {
        const res = await ApiService.getMediaHistory({
          year: selectedYear,
          userId: user.id,
          page: pageNumber,
        });
        console.log("MediaData", res);

        setMediaData(res.data);
        setTotalPages(Math.ceil(res.data.total / itemsPerPage));
      } catch (error) {
        console.error("Failed to fetch media:", error);
      } finally {
        setIsAPILoading(false);
      }
    };

    fetchMedia();
  }, [selectedYear, pageNumber, user]);

  const handleDownloadExcel = () => {
    if (!mediaData || mediaData.length === 0) return;
  
    const formattedData = mediaData.map((item, index) => ({
      "Sr No": (pageNumber - 1) * itemsPerPage + index + 1,
      "Temple Name": item.temple_name,
      "File Name": item.originalName,
      "Date of Upload": moment(item.createdAt).format("DD/MM/YYYY"),
      "Size of Upload (MB)": (item.size / (1024 * 1024)).toFixed(2),
      "Date of Sankirtan": moment(item.sankirtanDate).format("DD/MM/YYYY"),
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Media History");
  
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
  
    saveAs(fileData, `Media_History_${selectedYear}.xlsx`);
  };

  
  return (
    <div className="container pledge-responsive live-ranking dashboard-container transaction-bottom">
      <div className="col-12 user-welcome-card">
        <div className="view-history-header modal-gap">
          <div className="history-back" onClick={() => window.history.back()}>
            ←
          </div>
          <div className="year-download">
            <select
              className="form-select filter-text"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {yearsList.map((year, index) => (
                <option key={index} value={year}>
                  {year}
                </option>
              ))}
            </select>
            &nbsp;&nbsp;
            <button className="xl-download" onClick={handleDownloadExcel}>{t("Download")}</button>
          </div>
        </div>
      </div>

      <p className="view-history-title mb-4">{t("All Your Media Uploads")}</p>

      {!isAPILoading ? (
        <>
          {mediaData?.length > 0 ? (
            <div className="history-table">
              <Table responsive className="table history-custom-table">
                <thead>
                  <tr className="text-start sticky-header">
                    <th>{t("Sr.No")}</th>
                    <th>{t("Temple Name")}</th>
                    <th>{t("File Name")}</th>
                    <th>{t("Date of Upload")}</th>
                    <th>{t("Size of Upload")}</th>
                    <th>{t("Date of Sankirtan")}</th>
                  </tr>
                </thead>
                <tbody>
                  {mediaData.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-start">
                        {(pageNumber - 1) * itemsPerPage + index + 1}
                      </td>
                      <td className="text-start">{item.temple_name}</td>
                      <td className="text-start">{item.originalName}</td>
                      <td className="text-start">
                        {moment(item.createdAt).format("DD/MM/YYYY")}
                      </td>
                      <td className="text-start">
                        {(item.size / (1024 * 1024)).toFixed(2)} MB
                      </td>
                      <td className="text-start">
                        {moment(item.sankirtanDate).format("DD/MM/YYYY")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="right-section-wrapper">
              <h5 className="no-data-text">{t("No History Found.")}</h5>
            </div>
          )}
        </>
      ) : (
        <div className="right-section-wrapper">
          <h5 className="no-data-text">{t("Please wait loading...")}</h5>
        </div>
      )}
    </div>
  );
};

export default MediaHistoryComponent;
